import { ApiService } from "../../../../../core";
import { AdsCreationController, AdsCreationResponse, AdsUpdateResponse, IAds, IAdsCreationResponse, IProductsItemToAdsCreate, IProductsListToAdsCreate } from "../../core/controllers";

export class AdsCreationControllerImpl implements AdsCreationController {
    private api;
    constructor() {
        this.api = new ApiService(process.env.REACT_APP_API)
    }

    async onLoad(): Promise<IProductsItemToAdsCreate[]> {
        try {
            const responseJson: IProductsListToAdsCreate = await this.api.get(`/products-adm/list`);
            return responseJson.success ? responseJson.response : [];
        } catch (error) {
            return [];
        }
    }

    async adsRequest(referer: string): Promise<IAds | string> {
        try {
            const responseJson: AdsUpdateResponse = await this.api.get(`/ads/${referer}`);
            return responseJson.response;
        } catch (error) {
            if (error?.response?.status === 401) {
                throw ("401");
            } else {
                return `Não foi possível encontrar os dados de publicidade neste momento (${error.message})`;
            }
        }
    }

    async adsCreateRequest(target: string, data: string): Promise<AdsCreationResponse> {
        try {
            const responseJson: AdsCreationResponse = await this.api.get(`/${target}/${data}`);
            return responseJson;
        } catch (error) {
            return { success: true, response: [] };
        }
    }

    async onAdsCreateSubmit(formData: FormData): Promise<IAdsCreationResponse> {
        try {
            const responseJson = await this.api.post(`/ads`, formData);
            return responseJson;
        } catch (error) {
            if (error?.response?.status === 401) {
                throw ("401");
            } else {
                return `Não foi possível gravar os dados de publicidade neste momento (${error.message})`;
            }
        }
    }

    async onAdsUpdateSubmit(formData: FormData): Promise<IAdsCreationResponse> {
        try {
            const responseJson = await this.api.post(`/ads-update`, formData, true);
            return responseJson;
        } catch (error) {
            if (error?.response?.status === 401) {
                throw ("401");
            } else {
                return `Não foi possível gravar os dados de publicidade neste momento (${error.message})`;
            }
        }
    }

    // async onProductDelete(productId: string): Promise<AdsCreationResponse> {
    //     try {
    //         const responseJson: AdsCreationResponse = await this.api.delete(`/products-adm/${productId}`);
    //         return responseJson;
    //     } catch (error) {
    //         return { success: false, response: [] };
    //     }
    // }
}